module.exports = __webpack_public_path__ + "static/img/pigion.c3adc2b.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/rcv-images/pigion.png
// module id = 545
// module chunks = 1